var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_vm._l((_vm.descriptor),function(field){return _c('b-field',{key:field.value,class:{
      'text-error': _vm.error,
    }},[_c('b-radio',{attrs:{"value":_vm.value,"native-value":field.value},on:{"input":function($event){return _vm.$emit('input', field.value)}}},[_vm._v(" "+_vm._s(field.label)+" ")])],1)}),(_vm.error)?_c('span',{staticClass:"text-error"},[_vm._v(" "+_vm._s(_vm.error)+" ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }